import { useQuery } from "@tanstack/react-query";
import { api, throwIfError } from "../client";
import type { BuildId } from "@/types/identifiers";

export const auditLogKeys = {
  all: ["audit-log"] as const,
  byBuild: (buildId: BuildId, before?: string) =>
    [...auditLogKeys.all, "build", buildId, { before }] as const,
  summary: (buildId: BuildId) =>
    [...auditLogKeys.all, "summary", buildId] as const,
};

export function useAuditLog(buildId: BuildId, before?: string) {
  return useQuery({
    queryKey: auditLogKeys.byBuild(buildId, before),
    queryFn: async () => {
      const result = await api.GET("/api/builds/{build_id}/audit-log", {
        params: {
          path: { build_id: buildId },
          query: { before: before ?? undefined },
        },
      });
      return throwIfError(result, "Failed to fetch audit log");
    },
    enabled: !!buildId,
  });
}

export function useAuditSummary(buildId: BuildId) {
  return useQuery({
    queryKey: auditLogKeys.summary(buildId),
    queryFn: async () => {
      const result = await api.GET("/api/builds/{build_id}/audit-summary", {
        params: { path: { build_id: buildId } },
      });
      return throwIfError(result, "Failed to fetch audit summary");
    },
    enabled: !!buildId,
  });
}
